import { isEqual } from "lodash";
import { Base64 } from "js-base64";
import * as CONSTANTS from "./constants";
import moment from "moment";
import * as Excel from "exceljs";
import { saveAs } from "file-saver";
import imageCompression from "browser-image-compression";
import * as fileBase64Services from "controller/services/fileBase64Services";

var jwtDecode = require("jwt-decode");
var { formValidate } = require("./formValidate");

function goBack(e) {
  if (e) e.preventDefault();
  window.history.back();
}

function convertList(data) {
  return data.map((obj) => ({ ...obj, key: obj._id.$oid || obj._id }));
}

function convertSelOps(array, valueKey, labelKey, valueDisabled = []) {
  if (!array) return [];
  return array.map((item) => {
    let value = item[valueKey] || (item._id && (item._id.$oid || item._id));
    let label = item[labelKey];
    let disabled = valueDisabled.some(
      (x) => (x[valueKey] || (x._id && (x._id.$oid || x._id))) === value,
    );
    return { ...item, value, label, disabled };
  });
}

function convertSeltedOps(obj, value, label) {
  if (!obj) return null;

  if (Array.isArray(obj)) {
    obj.forEach((item, index) => {
      let vl = item[value] || (item._id && (item._id.$oid || item._id)) || null;
      let lb = item[label] || item.Ten || null;
      obj[index].value = vl;
      obj[index].label = lb;
    });
  } else {
    let vl = obj[value] || (obj._id && (obj._id.$oid || obj._id)) || null;
    let lb = obj[label] || obj.Ten || null;
    if (vl !== null && lb !== null) {
      obj.value = vl;
      obj.label = lb;
    } else {
      obj = null;
    }
  }

  return obj;
}

const parseJwt = function (token) {
  var decoded = jwtDecode(token);
  if (!decoded) return 0;
  return decoded;
};

const isEmpty = function (obj) {
  if (!obj) return !obj;
  if (obj instanceof Blob || obj instanceof ArrayBuffer) return false;
  return Object.getOwnPropertyNames(obj).length === 0;
};

const clone = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};

const compare = function (a, b) {
  const A = parseInt(a[`${"STT"}`]);
  const B = parseInt(b[`${"STT"}`]);

  let comparison = 0;
  if (A > B) {
    comparison = 1;
  } else if (A < B) {
    comparison = -1;
  }
  return comparison;
};

const decode = function (string) {
  return Base64.decode(string);
};

const encode = function (string) {
  return Base64.encode(string);
};

// Hàm chuẩn hóa tên trường
function normalizeKey(key) {
  if (!key) return "";
  return key
    .toLowerCase() // thành chữ thường
    .replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a")
    .replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e")
    .replace(/ì|í|ị|ỉ|ĩ/g, "i")
    .replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o")
    .replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u")
    .replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y")
    .replace(/đ/g, "d")
    .replace(
      /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
      " ",
    )
    .replace(/\s+/g, "") // thay khoảng trắng bằng rỗng
    .normalize("NFD") // tách dấu ra
    .replace(/[\u0300-\u036f]/g, "") // xóa dấu
    .replace(/[^a-z0-9\s]/g, "") // bỏ ký tự đặc biệt
    .trim();
}

function regexText(str) {
  str = str != undefined ? str : "";
  str = str.toLowerCase();
  str = str.replace(/\./g, "\\.");
  str = str.replace(/\*/g, "\\*");
  str = str.replace(/\?/g, "\\?");
  str = str.replace(/\(/g, "\\(");
  str = str.replace(/\)/g, "\\)");
  str = str.replace(/\{/g, "\\{");
  str = str.replace(/\}/g, "\\}");
  str = str.replace(/\[/g, "\\[");
  str = str.replace(/\]/g, "\\]");
  str = str.replace(/\$/g, "\\$");
  str = str.replace(/%/g, "\\%");
  str = str.replace(/\+/g, "(.{1})");

  str = str.replace(
    /a|à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,
    "(a|à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ)",
  );
  str = str.replace(/e|è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "(e|è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ)");
  str = str.replace(/i|ì|í|ị|ỉ|ĩ/g, "(i|ì|í|ị|ỉ|ĩ)");
  str = str.replace(
    /o|ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,
    "(o|ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ)",
  );
  str = str.replace(/u|ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "(u|ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ)");
  str = str.replace(/y|ỳ|ý|ỵ|ỷ|ỹ/g, "(y|ỳ|ý|ỵ|ỷ|ỹ)");
  str = str.replace(/d|đ/g, "(d|đ)");

  return { $regex: "(?i).*" + str + ".*" };
}

function insertParam(key, value, navigate, location) {
  key = encodeURI(key);
  let searchParams = new URLSearchParams(location.search);

  if (value) {
    searchParams.set(key, value);
  } else {
    searchParams.delete(key);
  }

  navigate({ search: searchParams.toString() });
}

async function insMulParams(
  listParams,
  navigate,
  location,
  replaceall = false,
) {
  if (!Array.isArray(listParams)) return;
  let kvp = location.search.substr(1).split("&");
  let repl = [];
  let x;

  if (Array.isArray(kvp)) {
    for (let i = kvp.length - 1; i >= 0; i--) {
      if (!kvp[i]) {
        kvp.splice(i, 1); // xóa từ cuối lên để tránh lỗi chỉ số
      }
    }
  }

  for (let i = 0; i < listParams.length; i++) {
    const param = listParams[i];
    if (param[0] && param[1]) {
      const key = param[0];
      const value = param[1];
      let indexParam = null;

      if (!replaceall) {
        for (let j = 0; j < kvp.length; j++) {
          const item = kvp[j];
          x = item.split("=");
          if (x.length === 2 && x[0] === key) {
            x[1] = value;
            indexParam = key;
            kvp[j] = x.join("=");
          }
        }
        if (!indexParam) {
          await kvp.push(`${key}=${value}`);
        }
      } else {
        await repl.push(`${key}=${value}`);
      }
    }
  }

  if (!replaceall) navigate({ search: kvp.join("&"), replace: replaceall });
  if (replaceall) navigate({ search: repl.join("&"), replace: replaceall });
}

function validateInput(val, regex) {
  if (!val && val !== 0) return true;
  if (!regex) return true;
  if (regex.global || regex.sticky) regex.lastIndex = 0;
  return regex.test(String(val).trim().toLowerCase());
}

function isoString2DateString(isoString, format = "DD/MM/YYYY") {
  if (!isoString) return "";

  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "";

  const pad = (n) => (n < 10 ? "0" + n : n);

  const replacements = {
    DD: pad(date.getDate()),
    MM: pad(date.getMonth() + 1),
    YYYY: date.getFullYear(),
    HH: pad(date.getHours()),
    mm: pad(date.getMinutes()),
    ss: pad(date.getSeconds()),
  };

  return format.replace(/DD|MM|YYYY|HH|mm|ss/g, (match) => replacements[match]);
}

function timestamp2DateString(timestamp, format = "DD/MM/YYYY") {
  if (!timestamp) return "";
  if (typeof timestamp === "object" && timestamp?.$numberLong) {
    timestamp = timestamp.$numberLong;
  }
  if (typeof timestamp === "string") {
    const trimmed = timestamp.trim();
    if (!trimmed) return "";
    const parsedDate = moment(trimmed);
    if (parsedDate.isValid()) {
      return parsedDate.format(format);
    }
  }
  const num = Number(timestamp);
  if (!isNaN(num) && num > 0) {
    const m = moment(num);
    if (m.isValid()) return m.format(format);
  }
  return "";
}

function expExcel(ref, page, name) {
  let myRows = [],
    maxCol = 0;

  /**
   * NGUYÊN TẮC:
   *  - ref.current (Ant Design v5 Table) là object wrapper, KHÔNG phải DOM Element.
   *    → KHÔNG gọi querySelector/classList trực tiếp trên ref.current.
   *  - Dùng children[] để đi vào DOM thực (từ children[0] trở đi là real DOM Element).
   *  - Từ antTableContainer (real DOM) trở đi có thể dùng querySelector/classList an toàn.
   *
   * Ant Design Table v5 — 3 cấu trúc DOM:
   *
   * [TH1] Không scroll / scroll.x:
   *   .ant-table-container
   *     .ant-table-content  (hoặc .ant-table-body)
   *       <table> → <thead> + <tbody>
   *
   * [TH2] scroll.y (fixed header):
   *   .ant-table-container
   *     .ant-table-header → <table> (<thead> THẬT + <tbody> rỗng)
   *     .ant-table-body   → <table> (<thead> clone ẩn + <tbody> data)
   *
   * PHÁT HIỆN TH2: firstChild.classList.contains("ant-table-header")
   * ĐÃ SỬA LỖI: KHÔNG dùng children.length >= 2 vì Ant Design thêm div phụ
   *   (placeholder, measurement...) vào .ant-table-container, làm children.length
   *   có thể >= 2 ngay cả khi KHÔNG có scroll.y → vào nhánh sai → 2 header!
   */

  // Bước 1: Điều hướng vào DOM thực qua children[] (an toàn với mọi ref.current)
  const antTableContainer =
    ref.current?.children?.[0]?.children?.[0]?.children?.[0]?.children?.[0];

  if (!antTableContainer) {
    alert("Không tìm thấy bảng dữ liệu!");
    return;
  }

  // Bước 2: firstChild là real DOM Element → classList.contains an toàn
  const firstChild = antTableContainer.children[0];
  if (!firstChild) {
    alert("Không tìm thấy bảng dữ liệu!");
    return;
  }

  // Helper: tìm section (<thead>/<tbody>) trong <table> bằng tagName
  function findSection(tableEl, sectionTag) {
    if (!tableEl) return null;
    const tag = sectionTag.toLowerCase();
    for (let i = 0; i < tableEl.children.length; i++) {
      if (tableEl.children[i].tagName.toLowerCase() === tag) {
        return tableEl.children[i];
      }
    }
    return null;
  }

  // Helper: đọc tất cả <tr> từ section, bỏ cột đầu (checkbox/STT) và cột cuối (Action)
  // Bỏ qua row có aria-hidden="true" (measure row của Ant Design khi scroll.x)
  function readSection(sectionEl) {
    if (!sectionEl) return;
    for (let ri = 0; ri < sectionEl.children.length; ri++) {
      const tr = sectionEl.children[ri];
      // Skip hidden/decorative rows (Ant Design thêm measure row aria-hidden="true"
      // vào <tbody> khi dùng scroll.x để đo độ rộng cột, nhưng innerText vẫn
      // đọc được dù row bị ẩn bằng height:0 → gây ra hàng header giả trùng)
      if (tr.getAttribute("aria-hidden") === "true") continue;
      const row = [];
      maxCol = tr.children.length > maxCol ? tr.children.length : maxCol;
      for (let ci = 1; ci < tr.children.length - 1; ci++) {
        row.push((tr.children[ci].innerText || "").trim());
      }
      if (row.some((cell) => cell !== "")) {
        myRows.push(row);
      }
    }
  }

  // Bước 3: Phát hiện chế độ fixed header bằng classList (real DOM, an toàn)
  const isFixedHeader =
    firstChild.classList.contains("ant-table-header") ||
    firstChild.classList.contains("ant-table-sticky-holder");

  let headerRowCount = 0;

  if (isFixedHeader) {
    // [TH2] Fixed header: header div (firstChild) + body div (sibling)
    // firstChild = .ant-table-header → children[0] = <table>
    const headerTable = firstChild.children[0];
    const theadEl = findSection(headerTable, "thead");
    readSection(theadEl);
    headerRowCount = theadEl ? theadEl.children.length : 0;

    // antTableContainer là real DOM → querySelector an toàn từ đây
    const bodyDiv = antTableContainer.querySelector(".ant-table-body");
    readSection(findSection(bodyDiv?.children[0], "tbody"));
  } else {
    // [TH1] Bảng đơn: firstChild = .ant-table-content hoặc .ant-table-body
    // → children[0] = <table>
    const table = firstChild.children[0];
    const theadEl = findSection(table, "thead");
    readSection(theadEl);
    headerRowCount = theadEl ? theadEl.children.length : 0;

    readSection(findSection(table, "tbody"));
  }

  // Nếu không có dữ liệu thì cảnh báo và không xuất
  if (myRows.length === 0) {
    alert("Không có dữ liệu để xuất!");
    return;
  }

  let date = timestamp2DateString(moment().valueOf());
  let fileName = name + "_" + page + "_" + date;
  const wb = new Excel.Workbook();
  const ws = wb.addWorksheet(name);

  // Thêm dữ liệu vào sheet
  ws.addRows(myRows);

  // Tự động dãn cột theo độ rộng dữ liệu
  ws.columns = myRows[0].map((_, colIndex) => {
    const maxLength = myRows.reduce((max, row) => {
      const cellValue = row[colIndex] ?? "";
      return Math.max(max, cellValue.toString().length);
    }, 12); // độ rộng tối thiểu là 12

    return { width: Math.min(maxLength + 2, 50) }; // tối đa 50 ký tự
  });

  // Xác định số hàng header
  const boldRows = headerRowCount > 0 ? headerRowCount : 1;

  // Áp dụng định dạng cho TẤT CẢ rows (1 vòng lặp duy nhất)
  for (let i = 0; i < myRows.length; i++) {
    const rowNum = i + 1;
    const isHeader = i < boldRows;
    const row = ws.getRow(rowNum);
    let estimatedMaxLines = 1;

    for (let j = 0; j < myRows[0].length; j++) {
      const cell = row.getCell(j + 1);
      const value = cell.value?.toString() || "";

      // Font Times New Roman cho toàn bộ — header: size 13 bold, data: size 12
      cell.font = {
        name: "Times New Roman",
        family: 2,
        size: isHeader ? 13 : 12,
        bold: isHeader,
      };

      // Căn lề: header → center, data → left
      cell.alignment = {
        vertical: "middle",
        horizontal: isHeader ? "center" : "left",
        wrapText: true,
      };

      // Kẻ viền mỏng đen
      cell.border = {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };

      // Màu nền xanh nhạt cho header
      if (isHeader) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD6E4F0" }, // xanh dương nhạt
        };
      }

      // Ước lượng chiều cao hàng
      const lines = value.split("\n").length + Math.floor(value.length / 40);
      if (lines > estimatedMaxLines) estimatedMaxLines = lines;
    }

    // Chiều cao hàng: header tối thiểu 22pt, data tối thiểu 18pt
    row.height = Math.max(isHeader ? 22 : 18, estimatedMaxLines * 15);
  }

  // Xuất file Excel
  wb.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
    });
    saveAs(blob, fileName + ".xlsx");
  });
}

const downloadFileFromBase64 = async (id, defaultFileName = "file") => {
  if (!id) {
    alert("Không có file để tải");
    return;
  }
  let files = await fileBase64Services.downloadFileBase64(id);
  if (!files || !files?.success) {
    alert("Download file không thành công");
    return;
  }

  let base64String = files?.data?.data;
  if (!base64String) return;

  // 1. Tách MimeType và Dữ liệu (Xử lý cả trường hợp không có prefix data:)
  let mimeType = "application/octet-stream";
  let base64Data = base64String;

  if (base64String.startsWith("data:")) {
    const parts = base64String.split(";base64,");
    if (parts.length >= 2) {
      mimeType = parts[0].substring(5); // remove 'data:'
      base64Data = parts.slice(1).join(";base64,");
    }
  }

  // Clean whitespaces/newlines/carriage returns
  base64Data = base64Data.replace(/[\s\r\n]+/g, "");

  // 2. Làm sạch MimeType (Xử lý lỗi @file/pdf hoặc các ký tự lạ)
  // Chuyển @file/pdf thành application/pdf hoặc trích xuất phần cốt lõi
  let cleanMime = mimeType.replace(/@file\//g, "application/").toLowerCase();

  // 3. Xác định đuôi file (Extension)
  const getExtension = (mime, data) => {
    // Thử đoán qua Magic Number (Đầu dữ liệu nhị phân) để chính xác tuyệt đối
    try {
      const binaryHeader = atob(data.substring(0, 32));
      if (binaryHeader.startsWith("%PDF")) return "pdf";
      if (binaryHeader.includes("PNG")) return "png";
      if (binaryHeader.includes("JFIF") || binaryHeader.includes("Exif"))
        return "jpg";
    } catch (e) { }

    // Nếu không đoán được qua byte, dùng map hoặc cắt chuỗi mime
    const mimeMap = {
      "application/pdf": "pdf",
      "image/jpeg": "jpg",
      "image/png": "png",
      "text/plain": "txt",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "docx",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        "xlsx",
    };

    if (mimeMap[cleanMime]) return mimeMap[cleanMime];

    // Cuối cùng: lấy phần sau dấu '/' (ví dụ: application/pdf -> pdf)
    return cleanMime.split("/").pop().split(";")[0] || "bin";
  };

  const extension = getExtension(cleanMime, base64Data);

  // 4. Tạo Blob và Download
  try {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: cleanMime });
    const blobUrl = URL.createObjectURL(blob);

    // Xử lý tên file: Nếu defaultFileName chưa có đuôi thì mới cộng thêm
    const fileName = defaultFileName.toLowerCase().includes(`.${extension}`)
      ? defaultFileName
      : `${defaultFileName}.${extension}`;

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    // Dọn dẹp
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error("Lỗi khi chuyển đổi file:", err);
    alert("Dữ liệu file không hợp lệ");
  }

  // let files = await fileBase64Services.downloadFileBase64(id);
  // if (!files || !files?.success) {
  //   alert("Download file không thành công");
  //   return;
  // }

  // let base64String = files?.data?.data;

  // // Nếu base64 có dạng: data:application/pdf;base64,JVBERi0xLjcK...
  // if (!base64String) return;
  // const matches = base64String.match(/^data:(.+);base64,(.+)$/);

  // if (!matches) {
  //   console.error("Base64 string is not in a valid format.");
  //   return;
  // }

  // const mimeType = matches[1]; // Ví dụ: application/pdf
  // const base64Data = matches[2];

  // const byteArray = Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
  // const blob = new Blob([byteArray], { type: mimeType });
  // const blobUrl = URL.createObjectURL(blob);

  // // Đoán đuôi file từ MIME type nếu chưa có
  // const extension = mimeType.split("/")[1];
  // const fileName = defaultFileName.includes(".")
  //   ? defaultFileName
  //   : `${defaultFileName}.${extension}`;

  // const link = document.createElement("a");
  // link.href = blobUrl;
  // link.download = fileName;
  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);
  // URL.revokeObjectURL(blobUrl);
};

const compressImageFile = async (file, maxSizeMB = 1) => {
  try {
    const options = {
      maxSizeMB,
      useWebWorker: true,
    };

    const compressedFile = await imageCompression(file, options);
    return compressedFile;
  } catch (error) {
    console.error("Lỗi khi nén ảnh:", error);
    throw error;
  }
};

const parseVnName = (fullName) => {
  if (!fullName || typeof fullName !== "string")
    return { Ho: "", ChuDem: "", Ten: "" };
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) return { Ho: parts[0], ChuDem: "", Ten: "" };
  if (parts.length === 2) return { Ho: parts[0], ChuDem: "", Ten: parts[1] };
  return {
    Ho: parts[0],
    ChuDem: parts.slice(1, -1).join(" "),
    Ten: parts[parts.length - 1],
  };
};

export {
  parseJwt,
  isEmpty,
  clone,
  goBack,
  decode,
  encode,
  compare,
  convertSelOps,
  convertSeltedOps,
  insertParam,
  insMulParams,
  regexText,
  validateInput,
  formValidate,
  timestamp2DateString,
  convertList,
  expExcel,
  downloadFileFromBase64,
  compressImageFile,
  normalizeKey,
  parseVnName,
};
